<script>
    import { DateFormatter } from '../../lib/dateFormatter.js';

    export let onReset;
    export let onBack;
    export let remainingCards = 0;
    export let nextUnlockDate = null;

    $: formattedDate = DateFormatter.formatNextUnlockDate(nextUnlockDate);
</script>

<div class="empty text-base-content/70">
    <div class="empty-icon">
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="64"
            height="64"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="text-primary/50"
        >
            <circle cx="12" cy="12" r="10"></circle>
            <polyline points="12 6 12 12 16 14"></polyline>
        </svg>
    </div>

    <p class="empty-title">Aucune carte à réviser pour le moment.</p>

    {#if remainingCards > 0}
        <div class="stats-info text-base-content/60">
            <p>
                <strong>{remainingCards}</strong> carte{remainingCards > 1 ? 's' : ''} en attente de révision
            </p>
            {#if formattedDate}
                <p class="next-unlock">
                    Prochaine carte disponible <strong>{formattedDate}</strong>
                </p>
            {/if}
        </div>
    {:else}
        <p class="empty-subtitle text-base-content/50">
            Toutes les cartes ont été révisées. Bon travail !
        </p>
    {/if}

    <div class="empty-actions">
        <button class="primary-btn btn btn-primary" on:click={onReset}>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
            >
                <polyline points="23 4 23 10 17 10"></polyline>
                <path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"></path>
            </svg>
            Réinitialiser les révisions
        </button>
        <button class="secondary-btn btn btn-outline btn-primary" on:click={onBack}>
            Retour
        </button>
    </div>
</div>

<style>
    .empty {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        min-height: 60vh;
        gap: 1rem;
    }

    .empty-icon {
        margin-bottom: 0.5rem;
    }

    .empty-title {
        font-size: 1.25rem;
        font-weight: 600;
        margin: 0;
    }

    .empty-subtitle {
        font-size: 0.9rem;
        margin: 0;
    }

    .stats-info {
        text-align: center;
        margin: 0.5rem 0;
        padding: 1rem;
        border-radius: 8px;
        background: rgba(var(--primary-rgb, 0, 0, 0), 0.05);
    }

    .stats-info p {
        margin: 0.5rem 0;
        font-size: 1rem;
    }

    .stats-info strong {
        color: var(--primary);
        font-weight: 700;
    }

    .next-unlock {
        font-size: 0.95rem;
    }

    .empty-actions {
        display: flex;
        gap: 1rem;
        margin-top: 1.5rem;
    }

    .empty button {
        border: none;
        padding: 0.6rem 1.2rem;
        border-radius: 6px;
        cursor: pointer;
        font-size: 0.95rem;
    }

    .empty .primary-btn {
        display: flex;
        align-items: center;
        gap: 0.5rem;
    }

    .primary-btn,
    .secondary-btn {
        padding: 0.8rem 1.5rem;
        border-radius: 8px;
        font-size: 1rem;
        font-weight: 600;
        cursor: pointer;
        transition: all 0.2s;
    }

    .primary-btn {
        border: none;
    }

    .secondary-btn {
        border: 2px solid;
    }

    @media (max-width: 640px) {
        .empty-actions {
            flex-direction: column;
            width: 100%;
        }

        .empty-actions button {
            width: 100%;
        }
    }
</style>
